export const methodLabel = (monitoringMethod) => {
  if (!monitoringMethod) return monitoringMethod
  return monitoringMethod === 'fabric' ? 'Fabric' : String(monitoringMethod).toUpperCase()
}

export const REACHABILITY_PROTOCOL_LABELS = { icmp: 'ICMP', tcp: 'TCP Connect' }

export const protocolLabel = (reachabilityProtocol) => {
  if (!reachabilityProtocol) return reachabilityProtocol
  return REACHABILITY_PROTOCOL_LABELS[reachabilityProtocol] || String(reachabilityProtocol).toUpperCase()
}
